import { Component, OnInit, Input } from '@angular/core';
import { Headers, ResponseContentType } from '@angular/http';
import { InterceptorService } from 'ng2-interceptors';
import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Observable';
import * as FileSaver from 'file-saver';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-order-last-comment',
    templateUrl: 'order-last-comment.component.html'
})
export class OrderLastCommentComponent  implements OnInit {
    loadingFile: boolean;
    @Input() lastComment: {};
    @Input() allComments: {}[];
    private headers = new Headers({'Content-Type': 'application/json'});

    constructor(private http: InterceptorService) {

    }

    ngOnInit() {
        this.loadingFile = false;
    }

    getCommentFile(fileName: string): Observable<any> {
        const options = {
            headers: this.headers,
            responseType: ResponseContentType.Blob
        };
        this.loadingFile = true;
        const params = {
            'fileName': fileName
        };
        return this.http.post(environment.apiUrl + 'site-api/get-comment-file', JSON.stringify(params), options)
            .map(
                function(response) {
                    return response.blob();
                }
            )
            .catch(this.handleError);
        ;

    }

    getFile(fileName: string) {
        this.getCommentFile(fileName)
            .finally(() => {
                this.loadingFile = false;
            })
            .subscribe((doc: Blob) => {
                FileSaver.saveAs(doc, fileName);
            })
        ;
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/orderLastComment/order-last-comment.component.ts